import React from 'react';

export type FilterIconName =
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'calendar'
  | 'eye'
  | 'search'
  | 'download'
  | 'layers'
  | 'station'
  | 'observations'
  | 'organisation'
  | 'project'
  | 'location'
  | 'monitoring'
  | 'matauranga'
  | 'arrow-up'
  | 'arrow-down'
  | 'close'
  | 'map'
  | 'clock'
  | 'reset'
  | 'site'
  | 'check'
  | 'external'
  | 'info';

interface FilterIconProps {
  name: FilterIconName;
  size?: number;
  className?: string;
  title?: string;
}

const PATHS: Record<FilterIconName, React.ReactNode> = {
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  'chevron-left': <path d="m15 18-6-6 6-6" />,
  'chevron-right': <path d="m9 18 6-6-6-6" />,
  calendar: (
    <>
      <rect x="3" y="4.5" width="18" height="16.5" rx="2" />
      <path d="M16 2.5v4M8 2.5v4M3 9.5h18" />
      <path d="M7.5 13h2M11 13h2M14.5 13h2M7.5 17h2M11 17h2M14.5 17h2" />
    </>
  ),
  eye: (
    <>
      <path d="M2.5 12s3.4-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.4 6.5-9.5 6.5S2.5 12 2.5 12Z" />
      <circle cx="12" cy="12" r="2.8" />
    </>
  ),
  search: (
    <>
      <circle cx="10.8" cy="10.8" r="6.3" />
      <path d="m15.5 15.5 4.2 4.2" />
    </>
  ),
  download: (
    <>
      <path d="M12 3v11" />
      <path d="m7.5 10.5 4.5 4.5 4.5-4.5" />
      <path d="M4.5 17v3h15v-3" />
    </>
  ),
  layers: (
    <>
      <path d="m12 3 9 5-9 5-9-5 9-5Z" />
      <path d="m3 12 9 5 9-5" />
      <path d="m3 16 9 5 9-5" />
    </>
  ),
  station: (
    <>
      <path d="M12 21s6-5.2 6-11a6 6 0 0 0-12 0c0 5.8 6 11 6 11Z" />
      <circle cx="12" cy="10" r="2.2" />
    </>
  ),
  observations: (
    <>
      <rect x="5" y="4" width="14" height="17" rx="2" />
      <path d="M9 4V2.5h6V4" />
      <path d="M8.5 9h7M8.5 13h7M8.5 17h4.5" />
    </>
  ),
  organisation: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3.5 20c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5" />
      <path d="M15.5 5.3a3 3 0 0 1 0 5.4" />
      <path d="M17 14.8c2 .7 3.5 2.6 3.5 5.2" />
    </>
  ),
  project: (
    <>
      <path d="M3 7.5h6l1.8 2H21v9.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 19V7.5Z" />
      <path d="M3 7.5V5.2A1.2 1.2 0 0 1 4.2 4h4.3l1.7 2H19" />
    </>
  ),
  location: (
    <>
      <path d="M12 21s6-5.2 6-11a6 6 0 0 0-12 0c0 5.8 6 11 6 11Z" />
      <circle cx="12" cy="10" r="2.2" />
    </>
  ),
  monitoring: <path d="M3 12h4l2.5-6 5 12 2.5-6h4" />,
  matauranga: (
    <>
      <path d="M20 4c-8 0-14 3.5-14 9.5A5.5 5.5 0 0 0 11.5 19C17.5 19 20 12 20 4Z" />
      <path d="M4 21c1.5-5 5-8.5 10-11" />
    </>
  ),
  'arrow-up': <path d="m6 14 6-6 6 6" />,
  'arrow-down': <path d="m6 10 6 6 6-6" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  map: (
    <>
      <path d="m3 6 5-2 8 3 5-2v14l-5 2-8-3-5 2V6Z" />
      <path d="M8 4v14M16 7v14" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  reset: (
    <>
      <path d="M4.5 9A8 8 0 1 1 6 17.5" />
      <path d="M4.5 4.5V9H9" />
    </>
  ),
  site: (
    <>
      <path d="M12 21s6-5.2 6-11a6 6 0 0 0-12 0c0 5.8 6 11 6 11Z" />
      <circle cx="12" cy="10" r="2.2" />
    </>
  ),
  check: <path d="m5 12.5 4.2 4.2L19 7" />,
  external: (
    <>
      <path d="M14 4h6v6" />
      <path d="M20 4 10.5 13.5" />
      <path d="M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 11v5M12 8h.01" />
    </>
  ),
};

const FilterIcon: React.FC<FilterIconProps> = ({ name, size = 18, className, title }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden={title ? undefined : true}
    role={title ? 'img' : undefined}
    focusable="false"
  >
    {title ? <title>{title}</title> : null}
    {PATHS[name]}
  </svg>
);

export default FilterIcon;
